import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatLauncherComponent } from './components/chat-launcher/chat-launcher.component';
import { ChatShellComponent } from './components/chat-shell/chat-shell.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { ChatThreadComponent } from './components/chat-thread/chat-thread.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { MarkdownPipe } from './pipes/markdown.pipe';

@NgModule({
  declarations: [
    ChatLauncherComponent,
    ChatShellComponent,
    ChatHistoryComponent,
    ChatThreadComponent,
    ChatInputComponent,
    MarkdownPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTooltipModule,
  ],
  exports: [
    ChatLauncherComponent,
    ChatShellComponent,
  ],
})
export class ChatModule { }
